export default {
    loadfarm({commit},payload){
        commit("loadfarm", payload)
    },
}